import { render, staticRenderFns } from "./CostosArticulos.vue?vue&type=template&id=4ca0f76f&"
import script from "./CostosArticulos.vue?vue&type=script&lang=js&"
export * from "./CostosArticulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports